export const configuraciones = {
    //server: 'http://localhost:8000/api/',
    server: 'https://3bio.bios-io.co/api/',
    //server: 'http://10.0.80.204:8000/api/',
    
};